module.exports = __webpack_public_path__ + "static/img/brand-4.22e3e3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-4.svg
// module id = wNgS
// module chunks = 0